import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const PageWrapper = styled.div`
  width: 100%;
  padding: 50px 0 0;
`;

export const FormCard = styled.section`
  max-width: 1160px;
  margin: 0 auto;
  padding: 36px 56px 44px;
  background-color: ${({ theme }) => theme.COLORS.HEADERBG};
  border: 1px solid
    ${({ theme }) =>
      theme.value === "light"
        ? theme.COLORS.LIGHTGRAYBORDER
        : theme.COLORS.WIDGETCOLOR};

  border-radius: 6px;

  ${mediaQuery.isTablet} {
    padding: 24px;
  }
`;

export const TopWrapper = styled.ul`
  display: grid;
  grid-template-columns: 150px 1fr;
  row-gap: 18px;
  column-gap: 26px;
  color: ${({ theme }) =>
    theme.value === "light" ? theme.COLORS.TEXT : COLORS.WHITE};

  > li {
    display: contents;
  }

  .title {
    font-size: ${calcRem(16)};
    font-weight: 500;
  }

  .content {
    font-size: ${calcRem(16)};
    font-weight: 400;
  }

  ${mediaQuery.isTablet} {
    .title,
    .content {
      font-size: ${calcRem(15)};
    }
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid
    ${({ theme }) =>
      theme.value === "light"
        ? theme.COLORS.LIGHTGRAYBORDER
        : theme.COLORS.WIDGETCOLOR};
  margin: 34px 0 30px;
`;

export const FormLayout = styled.div`
  display: grid;
  gap: 28px;
  color: ${({ theme }) =>
    theme.value === "light" ? theme.COLORS.TEXT : COLORS.WHITE};
`;

export const MainGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  gap: 22px;
  align-items: start;

  ${mediaQuery.isTablet} {
    grid-template-columns: 1fr;
  }
`;

export const RightColumn = styled.div`
  display: grid;
  gap: 28px;
`;

export const Field = styled.div`
  min-width: 0;

  textarea {
    min-height: 150px;
  }
`;

export const Label = styled.div`
  margin-bottom: 9px;
  font-size: ${calcRem(16)};
  font-weight: 500;

  ${mediaQuery.isTablet} {
    font-size: ${calcRem(14)};
  }
`;

export const Required = styled.span`
  color: ${COLORS.VALIDATERED};
`;

export const MapBox = styled.div`
  margin-top: 14px;
  border: 1px solid ${({ theme }) => theme.COLORS.BORDER};
  border-radius: 4px;
  overflow: hidden;
  min-height: 400px;
  height: 400px;

  > div {
    width: 100%;
    height: 100%;
  }

  ${mediaQuery.isTablet} {
    min-height: 340px;
  }
`;

export const ThumbBox = styled.div`
  position: relative;
  width: 100%;
  min-height: 220px;
  max-height: 220px;
  border: 1px solid ${({ theme }) => theme.COLORS.BORDER};
  border-radius: 4px;
  overflow: hidden;
  background: ${({ theme }) => theme.COLORS.TEXT};

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const ThumbActionButton = styled.button`
  position: absolute;
  right: 12px;
  bottom: 12px;
  border: none;
  border-radius: 3px;
  padding: 8px 14px;
  font-size: ${calcRem(13)};
  font-weight: 600;
  color: #fff;
  background: ${COLORS.COMPANY};
  cursor: pointer;
`;

export const BottomButtonBar = styled.div`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  gap: 14px;
  padding: 40px 0;
`;

export const ThumbPreviewBox = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 540px;
  border: 1px solid ${COLORS.COMPANY};
  border-radius: 18px;
  overflow: hidden;
  background: #f2f2f2;
  height: 200px;

  > img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ThumbPreviewEmpty = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.COLORS.TEXT};
  font-size: ${calcRem(28 / 2)};
`;

export const ThumbActionGrid = styled.div`
  margin: 24px auto 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  width: 400px;

  ${mediaQuery.isMobile} {
    grid-template-columns: 1fr;
  }
`;

export const ThumbActionItem = styled.button`
  flex-direction: column;
  ${FLEX.FlexCenterCenter};
  gap: 10px;
`;

export const ThumbActionIconBox = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.COLORS.LIGHTGRAY};
  color: ${({ theme }) => theme.COLORS.BORDER};
  ${FLEX.FlexCenterCenter}
`;

export const ThumbActionLabel = styled.span`
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-weight: 400;
`;

export const ThumbModalInfoText = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.COLORS.TEXT};
  font-size: ${calcRem(14)};
  line-height: 1.5;
`;

export const ModalBackButton = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: ${({ theme }) => theme.COLORS.WHITE}80;
  ${FLEX.FlexCenterCenter};
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;
`;

export const ModalHeaderText = styled.div`
  flex: 1;
  text-align: center;
`;

export const ModalTitle = styled.h3`
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-size: ${calcRem(22)};
  font-weight: 700;
  line-height: 1.2;
`;

export const ModalSubTitle = styled.p`
  margin-top: 6px;
  color: ${({ theme }) => theme.COLORS.WHITE}70;
  font-size: ${calcRem(14)};
  line-height: 1.4;
`;

export const ModalButtonRow = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 10px;
`;

export const ThumbnailModalBody = styled.div`
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
`;

export const UploadBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const UploadActionRow = styled.div`
  width: 100%;
  ${FLEX.FlexBetweenCenter}
  gap: 10px;

  > p {
    margin: 0;
    min-width: 0;
    flex: 1;
    text-align: left;
  }

  > button {
    flex-shrink: 0;
  }
`;

export const CameraGrid = styled.div`
  overflow-x: hidden;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding-right: 2px;
  padding-top: 10px;
  width: 100%;
`;

export const CameraThumbButton = styled.button<{
  selected: boolean;
  imageFit?: "cover" | "contain";
}>`
  position: relative;
  width: 100%;
  min-width: 0;
  ${FLEX.FlexCenterCenter}
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid
    ${({ selected, theme }) =>
      selected ? theme.COLORS.SELECTED : "transparent"};
  background-color: ${({ theme }) => theme.COLORS.LIGHTGRAY};
  padding: ${({ imageFit }) => (imageFit === "contain" ? "8px" : "0")};

  > img {
    width: 100%;
    height: 86px;
    max-width: 100%;
    max-height: 100%;
    object-fit: ${({ imageFit }) => imageFit || "cover"};
    object-position: center;
    display: block;
  }

  .selected-mark {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.COLORS.SELECTED};
    color: ${COLORS.WHITE};
    font-size: ${calcRem(12)};
    ${FLEX.FlexCenterCenter};
  }
`;
